<div class="flex flex-col gap-3">
  <h1>
    {{ 'startPage.welcome' | translate: { name: firstName } }}
  </h1>
  <p class="text-muted-color">{{ 'startPage.description' | translate }}</p>

  <div
    class="card-grid grid grid-cols-1 @xl:grid-cols-2 @4xl:grid-cols-3 gap-3"
  >
    @for (group of groups(); track group.labelKey) {
      @for (card of group.cards; track card.routerLink) {
        <p-card styleClass="h-full">
          <div
            class="flex flex-col items-center justify-between gap-2 p-2 h-full text-center"
          >
            <span class="label font-medium text-muted-color">
              {{ group.labelKey | translate }}
            </span>
            <div class="flex flex-col items-center gap-1">
              <i class="{{ card.icon }} text-2xl text-primary"></i>
              <span class="font-semibold">{{ card.label | translate }}</span>
              <span class="text-sm text-muted-color">
                {{ card.dashboard!.descriptionKey | translate }}
              </span>
            </div>
            <a [routerLink]="card.routerLink" class="mt-auto pt-1">
              <p-button
                [label]="card.dashboard!.buttonKey | translate"
                [outlined]="true"
                size="small"
              />
            </a>
          </div>
        </p-card>
      }
    }
  </div>
</div>
